module.exports = __webpack_public_path__ + "static/media/view6.be6070f6.jpg";